"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildClassName = void 0;
const markdown_module_css_1 = __importDefault(require("@vtblife/react-markdown-styles/dist/markdown.module.css"));
const react_markdown_types_1 = require("@vtblife/react-markdown-types");
const classnames_1 = __importDefault(require("classnames"));
const react_markdown_utils_1 = require("@vtblife/react-markdown-utils");
function buildClassName({ footnote = false, imageSize = react_markdown_types_1.ImageSizeType.Original, inline = false, styles = markdown_module_css_1.default, unorderedListStyle = react_markdown_types_1.MarkdownUnorderedListStyle.Dot, breakpoints, }) {
    var _a, _b, _c;
    const breakpointsClassNames = react_markdown_utils_1.getBreakpointsClassNames({
        breakpoints,
        mappers: {
            colorVariant: colorVariant => {
                const classes = [];
                if (footnote) {
                    classes.push(`markdown-content-footnote-${colorVariant}`);
                }
                else {
                    if (!inline) {
                        classes.push(`${colorVariant}-variant`);
                    }
                }
                return classes;
            },
            sizeVariant: sizeVariant => (!footnote ? [`markdown-content-${sizeVariant}`] : null),
            paddingSize: paddingSize => [`markdown-padding-size-${paddingSize}`],
        },
    });
    return classnames_1.default((_a = breakpointsClassNames.colorVariant) === null || _a === void 0 ? void 0 : _a.map(className => styles[className]), (_b = breakpointsClassNames.paddingSize) === null || _b === void 0 ? void 0 : _b.map(className => styles[className]), (_c = breakpointsClassNames.sizeVariant) === null || _c === void 0 ? void 0 : _c.map(className => styles[className]), styles[`markdown-unordered-list-${unorderedListStyle}`], {
        [styles.imageFullWidth]: imageSize === react_markdown_types_1.ImageSizeType.FullWidth,
    });
}
exports.buildClassName = buildClassName;
//# sourceMappingURL=build-class-name.js.map